import React from "react";
import "./index.less";

class chargingMemberServiceAgreement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div className="page_type_h5">
                <article id="chargingMemberServiceAgreement">
                    <h2>VIP会员服务协议</h2>
                    <section>
                        本《VIP会员服务协议》（下称“本协议”）是远程慧联用户（下称“您”）与浙江绿色慧联之间关于用户成为远程慧联VIP会员且享受远程慧联提供的远程慧联VIP会员服务（“本服务”）所订立的协议。
                    </section>
                    <section>
                        <b>
                            请您在使用远程慧联VIP会员服务之前认真阅读本协议、《绿色慧联用户协议》、《绿色慧联隐私政策》及“远程慧联VIP会员”页面上的具体说明（统称为“全部协议”）。您使用本服务的行为（包括点击同意本协议并就本服务支付任何款项）将视为您阅读并理解了全部协议，同意全部协议，并接受本协议、《绿色慧联用户协议》、《绿色慧联隐私政策》的约束。本协议未约定内容，以《绿色慧联用户协议》、《绿色慧联隐私政策》约定为准。
                        </b>
                    </section>
                    <section>
                        1.服务条款的接受与修改
                        <p>
                            <b>
                                1.1本服务协议构成您（只限个人）使用远程慧联所提供的VIP会员服务的必要前提，若您不接受本协议中的各项条款，您将无法使用本协议所涉及的相关服务。您一旦开始使用，即表示您已同意并接受本协议所有条款的约束。
                            </b>
                        </p>
                        <p>
                            <b>
                                1.2您在使用本服务时须具备相应的权利能力和行为能力，能够独立承担法律责任。若您年龄未满18周岁，则必须在父母或其他监护人的监护下才能使用本服务。您继续使用本服务的行为视为将视为已得到父母或法定监护人的同意与许可。
                            </b>
                        </p>
                        <p>
                            1.3远程慧联将根据市场环境、业务发展情况对本服务条款进行修改，一旦服务条款有所更新，远程慧联将在相关页面上提示修改的内容；若您不同意本协议的修改，您有权取消现有服务并停止使用；反之，若您继续使用远程慧联提供的服务，则意味着您已充分理解并接受了本协议的所有更新内容。
                        </p>
                        <p>
                            1.4为方便您及时获知远程慧联的相关信息、与本服务和本协议相关的信息，您同意远程慧联采用以下任意一种或多种方式向您发送通知：页面提示、弹窗、消息通知和您的联系方式（例如电话、短信）。所有通知自远程慧联发出之时即视为已有效送达给您。若同时使用多种通知方式，送达时间以最先发出的方式为准。
                        </p>
                    </section>
                    <section>
                        2.会员服务说明
                        <p>
                            <b>
                                远程慧联VIP会员是远程慧联协同各合作伙伴打造的收费增值服务，您需要在远程慧联APP/小程序/H5页面等远程慧联提供的网络平台（以下合称“远程慧联平台”）相应权益开通页面开通VIP会员下相应权益并支付相应费用才能成为远程慧联VIP会员。
                            </b>
                        </p>
                        <p>2.1权益说明</p>
                        <p>
                            <b>
                                （1）服务权益包括充电权益及后续会陆续上线的租车权益、商城权益等，您可以享受您付费开通的相关权益，权益内容以页面实际展示为准。相应权益有有效期限制，有效期指您购买相应权益的时长。
                            </b>
                            有效期可通过购买、兑换等方式获得。超过有效期后，远程慧联会员服务自动失效，您将无法继续享有相应服务权益。
                        </p>
                        <p>
                            （2）您开通相应权益的，我们将在您开通的同时发放对应VIP会员权益，例如充电权益内容包括会员场站享充电服务费折扣优惠、充电服务费抵扣券等，具体充电折扣、会员场站站点、抵扣券面额等以远程慧联平台公布的信息为准。
                        </p>
                        <p>
                            （3）您知悉并同意，VIP会员权益内容及购买价格可能会不定期更新。远程慧联通过与合作伙伴的合作，为您提供VIP会员服务。服务的具体费用、场站站点、充电服务费优惠、权益内容等，均依据远程慧联及合作伙伴的销售、补贴及定价政策确定。远程慧联可能会根据合作伙伴的政策变动、价格调整或要求，对VIP会员权益（如场站站点、开通费用、服务费折扣、权益内容等）进行部分或全部调整。有关权益内容的变更，远程慧联将在服务页面发布通知或公告，您可通过远程慧联APP查阅最新的会员权益详情。
                        </p>
                        <p>2.2虚拟产品说明</p>
                        <p>
                            （1）您在使用本服务过程中可能获得由我们提供各种券及各种有偿或无偿积分等虚拟产品。
                        </p>
                        <p>
                            <b>
                                （2）充电用户领取/购买的虚拟产品仅能用于远程慧联官方渠道公布的指定用途，不能退货、兑换现金或转让、买卖、置换、抵押等，在使用后亦不会恢复。
                            </b>
                        </p>
                        <p>
                            <b>
                                （3）远程慧联在此善意提醒您，虚拟产品中还有需要进行额外付费的服务。虚拟商品如需要额外付费购买的，请谨慎购买，一经下单不支持退款。
                            </b>
                        </p>
                        <p>
                            （4）充电用户通过正当途径获取的各类虚拟产品，不得进行销售。若发现，用户有可能被加入黑名单、限制使用VIP会员的相关权益。
                        </p>
                        <p>2.3第三方服务内容</p>
                        <p>
                            <b>
                                （1）本服务页面可能会展示第三方服务，在您点击该第三方服务后，可能将跳转至第三方为您提供服务。该类服务由第三方提供与负责。远程慧联在此善意提醒您，第三方会依据其平台规则（包括会员规则，如涉及）向您提供服务并收取会员费（如有）。
                            </b>
                        </p>
                        <p>
                            （2）若您购买联合会员服务或因购买远程慧联VIP会员服务而获赠第三方会员服务的，远程慧联仅提供远程慧联VIP会员服务，不对第三方的会员服务负责。第三方会员服务的权益、使用、收费规则等，将由第三方执行和向您解释，您亦可以前往第三方平台查询相关规则。
                        </p>
                        <p>2.4活动参与</p>
                        <p>
                            在本服务期限内，您有权选择参加由远程慧联组织的活动并享有由远程慧联提供的各项优惠。具体活动及优惠的内容及规则以远程慧联实际提供为准。
                        </p>
                        <p>2.5其他说明</p>
                        <p>
                            （1）本服务涉及的远程慧联产品所有权以及相关软件知识产权归远程慧联所有。远程慧联所提供的VIP会员服务将按照本协议条款和页面公示的规则严格执行。您在享受并使用本服务过程中，若违反相关法律法规或违背本协议条款约定的，远程慧联有权要求您纠正，并保留追究您相应责任的权利。
                        </p>
                        <p>
                            （2）本服务仅限于远程慧联用户在远程慧联平台开通VIP会员后使用。任何通过其他非法手段将VIP会员服务与远程慧联平台分离的行为，均不属于本协议中约定的远程慧联提供的服务。因此产生的所有法律后果由行为人自行承担，此外，远程慧联将依法追究其法律责任。
                        </p>
                        <p>
                            （3）您需自行负责妥善保管、正确使用及维护您在远程慧联申请的账户、账户信息及密码，并采取必要的保密措施。因非远程慧联原因导致的账户密码泄露，或因您保管、使用、维护不当造成的损失，远程慧联不承担任何责任。
                        </p>
                        <p>
                            （4）远程慧联不对您因第三方的行为或不作为造成的损失承担任何责任，包括但不限于支付服务和网络接入服务、任意第三方的侵权行为。
                        </p>
                    </section>
                    <section>
                        3.开通远程慧联VIP会员资格
                        <p>
                            3.1在成为远程慧联VIP会员之前，您须以真实有效的信息注册成为远程慧联用户。您所填写的内容与个人资料必须真实有效，否则远程慧联有权拒绝您的申请或撤销您远程慧联VIP会员资格，并不予任何赔偿或退还会员费。您的个人资料发生变化，应及时修改注册的个人资料，否则由此造成的远程慧联VIP会员权利不能全面有效行使的责任由您自行承担，远程慧联有权因此取消您的远程慧联VIP会员资格，并不予退还会员费或给予其他任何形式的任何赔偿。
                        </p>
                        <p>
                            3.2您应自行负责妥善保管您的远程慧联账户、账户信息和账户密码。您应采取一切必要且有效的措施保护您的账户信息和密码。在适用法律允许的最大范围内，远程慧联无须承担非因远程慧联原因导致的账户信息（包括您的账户密码）泄露，和/或因您使用或保管账户不当导致的任何损失。
                        </p>
                        <p>
                            3.3您可通过登录远程慧联“VIP会员”以查看您的VIP会员账户信息
                        </p>
                    </section>
                    <section>
                        4.价格和收费
                        <p>
                            4.1本服务是远程慧联与合作伙伴联合推出的收费增值服务，您需根据我们的收费标准支付相应费用以使用该服务。未来我们也可能提供其他获得VIP会员服务的方式和途径，以远程慧联平台公示和通知为准。
                            <b>
                                远程慧联可能会根据合作伙伴的销售及营销策略调整VIP会员费用，具体费用标准以页面展示的价格为准，如存在多种类型的VIP会员权益的，因每种会员权益服务、有效期限等不一致，每种会员权益服务的价格会存在差异。若用户在费用调整公示发布前已开通某项会员权益服务，其会员费用将不受影响；反之，若用户在公示发布后开通某项会员权益服务，则需按照公示的新标准支付会员费用；此外，因每个用户使用优惠券、参加活动的情况不同，可能出现实际结算价格和展示价格不一致的情况，对此您予以理解，最终以实际结算价格为准。
                            </b>
                        </p>
                        <p>4.2价格说明</p>
                        <p>
                            （1）VIP会员购买页面展示的划横线价格（如有）指过往销售过的价格或曾经展示过的销售价格，仅供参考；未划线价格指实时标价。具体成交价格根据活动情况、用户使用优惠券、折扣券等情况发生变化，最终以订单结算页价格为准。
                        </p>
                        <p>
                            （2）您所享受的优惠/活动价格仅适用于我们通知您的优惠/活动期间。在优惠/活动期结束后，本VIP会员服务的价格则以“VIP会员”公布的费用为准。
                        </p>
                        <p>
                            （3）您可以根据“VIP会员”页面显示的服务期限自行选择按月度、季度或年度支付会员费。
                        </p>
                        <p>
                            4.3您可以选择通过以下方式支付VIP会员费：登记在您名下的第三方支付账户（如微信、支付宝）或其他远程慧联接受的支付方式。您使用第三方支付服务支付会员费，您还将受到该第三方支付服务的政策、条款和条件的约束。
                            <b>
                                远程慧联在此声明：远程慧联从未授权任何第三方单位或个人销售、转让远程慧联VIP会员服务，任何未经授权销售远程慧联VIP会员服务的属于非法销售，远程慧联有权追究其法律责任。
                            </b>
                        </p>
                        <p>
                            4.4您保证，您有权使用您的支付账户向我们支付会员费，该等使用不侵犯任何第三方的权利。只有在您成功全额支付您的会员权益相应费用，且满足成为VIP会员的其他所有适用要求后方可享受本服务。
                        </p>
                        <p>
                            <b>
                                4.5请注意，您的VIP会员资格不可转让，相应服务一经开通后不可退款。但如因相应服务不能提供或者我们违约导致您完全无法使用相应服务、本协议另有规定、法律法规要求应当退款或我们同意退款的情况下，我们将为您办理退款。
                            </b>
                        </p>
                        <p>
                            4.6您理解并同意，对于账单错误或扣款错误的情况，我们原则上不承担任何责任。如果扣款错误确实是由我们引起的，我们承诺在收到相关错误通知后，负责及时更正该错误。
                        </p>
                        <p>
                            4.7远程慧联可能会根据合作伙伴的政策不时调整会员费（调整包括但不限于促销、涨价等）、支付方式和服务期限，我们将依据第1.4条规定的通知方式公布此类调整。
                        </p>
                    </section>
                    <section>
                        5.用户行为规范
                        <p>
                            5.1本服务仅限于开通账号自行使用；本服务期内不能在远程慧联帐号之间转移，禁止赠与、借用、转让或售卖。
                            <b>
                                否则远程慧联有权在未经通知的情况下取消转让账户、受让账户的远程慧联VIP会员服务资格，由此带来的损失由用户自行承担。
                            </b>
                        </p>
                        <p>
                            5.2若您的行为违反本协议或违反国家相关法律法规，或远程慧联认为您的行为有损远程慧联或他人声誉及利益，远程慧联有权取消您的远程慧联VIP会员资格而无需给予任何补偿。
                        </p>
                        <p>
                            5.3任何人不得以盗窃、利用系统漏洞等非法途径，也不得在未获远程慧联授权的非渠道获取或购买远程慧联VIP会员服务，否则远程慧联有权取消VIP会员的服务资格。由此引发的问题由您自行承担，远程慧联不负任何责任。
                        </p>
                        <p>
                            5.4被取消远程慧联VIP会员资格的用户，将不能再参加由远程慧联组织的活动并不可再享有由远程慧联提供的各项优惠及增值服务。
                        </p>
                        <p>
                            5.5远程慧联提供的远程慧联VIP会员服务内容不得用于商业、盈利等用途，只可供个人使用。
                        </p>
                        <p>
                            5.6
                            禁止以非法目的使用远程慧联VIP会员服务提供的任何服务，包括但不限于下列情况：通过非法手段对远程慧联VIP会员账户的服务期限、消费金额、交易状态进行修改；通过远程慧联收集第三方资料信息，破坏或盗取第三方账号，发送诈骗邮件和垃圾邮件等非法信息，侵犯第三方合法权益，包括但不限于隐私权、知识产权、财产权等；通过非远程慧联认可的方式获得远程慧联VIP会员服务提供的优惠权限；
                        </p>
                    </section>
                    <section>
                        6.协议变更
                        <p>
                            6.1
                            <b>
                                远程慧联依据本协议1.3的约定变更服务内容、服务方式以及本用户协议内容，如果您不同意远程慧联的变更，有权选择取消并立即停止使用已经获取的对应的全部或部分服务并和我们取得联系，我们将为您注销会员资格，并停止提供VIP会员服务，并为您办理相关手续，但远程慧联不退还自开通远程慧联VIP会员服务至提出终止远程慧联VIP会员服务所在月的已享受的VIP会员服务的部分费用；如果您继续使用VIP会员服务，则视为您已经接受远程慧联对协议内容的调整。
                            </b>
                        </p>
                        <p>
                            6.2
                            <b>
                                远程慧联对VIP会员服务协议一旦进行修改，将在页面上公示修改的内容。一经公布即视为通知已送达给您。
                            </b>
                        </p>
                        <p>
                            6.3远程慧联VIP会员服务提供的使用期限中包含远程慧联解决故障、服务器维修、调整、升级等所需用的合理时间，对上述情况所需用的时间远程慧联不予补偿并保留解释权。
                        </p>
                        <p>
                            6.4您在使用远程慧联所提供的服务时，如遭受任何人身或财务的损失、损害或伤害，不论原因如何，远程慧联均不负责任。由于您将个人密码告知他人或与他人共享注册账户，由此导致的任何个人资料泄露，远程慧联不负任何责任。
                        </p>
                    </section>
                    <section>
                        7.服务的中断和终止
                        <p>
                            7.1因发生远程慧联不可抗拒的事由，如政府行为、不可抗力等因素，导致远程慧联VIP会员服务无法继续，远程慧联会以最快的速度通知远程慧联VIP会员，但不承担由此对远程慧联VIP会员造成的任何损失。
                        </p>
                        <p>
                            7.2
                            <b>
                                如您违反或被视为违反本服务条款中的相关内容，远程慧联有权立即终止您已购买的所有服务，以及取消您的远程慧联VIP会员账户和使用权限，
                            </b>
                            并会将您违反约定的相关情况和采取的措施通知您，您可以通过我们告知的联系方式向我们提出申诉，如申诉的情况属实我们将恢复向您提供服务。因您违反相关约定造成我们停止服务的情况，
                            <b>
                                我们将不退还任何已缴纳的会员服务费，并且不承担任何责任。
                            </b>
                        </p>
                        <p>
                            7.3远程慧联未行使或延迟行使其在本协议项下的权利并不构成对这些权利的放弃，而单一或部分行使其在本协议项下的任何权利并不排斥其任何其它权利的行使。远程慧联有权随时要求您继续履行义务并承担相应的违约责任。
                        </p>
                    </section>
                    <section>
                        8.其他
                        <p>
                            <b>《绿色慧联用户协议》、《绿色慧联隐私政策》</b>
                        </p>
                    </section>
                </article>
            </div>
        );
    }
}

export default chargingMemberServiceAgreement;



// WEBPACK FOOTER //
// ./src/staticPage/chargingMemberServiceAgreement/index.js